/**
 * Wrapes an input stream to cache values, optionally providing an initial value
 * @param r
 * @param initialValue
 * @returns
 */
export function cache(r, initialValue) {
    let lastValue = initialValue;
    r.onValue(value => {
        lastValue = value;
    });
    return {
        ...r,
        last() {
            return lastValue;
        },
        resetCachedValue() {
            lastValue = undefined;
        }
    };
}
